import {useContext} from "react";
import {AppMetadataContext} from "../contexts/app-metadata-context";
import {AppMetadataContextType} from "../models/interfaces/app-metadata-context-type.interface";

export const useAppMetadata = (): AppMetadataContextType => {
    const context = useContext(AppMetadataContext);

    if (!context) {
        throw new Error("useAppMetadata must be used within an AppMetadataProvider");
    }

    return context;
};



